import React from 'react';
import './ShopifyPolarisShell.css';

/** Neutral Polaris loading state for embedded Shopify admin (no Volugraph logo). */
function ShopifyLoadingScreen({ className = '' }) {
  return (
    <div
      className={`shopify-app-shell shopify-loading-screen${className ? ` ${className}` : ''}`.trim()}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <s-stack gap="small" align="center" justify="center">
        <s-spinner size="large" />
        <s-text tone="subdued">Loading…</s-text>
      </s-stack>
    </div>
  );
}

export default ShopifyLoadingScreen;
